<template>
  <div class="pt-4">
    <!-- <h3 class="text-black font-weight-bold">Storico Prenotazioni</h3> -->
    <h1 class="pb-2">Storico Prenotazioni</h1>
    <b-container
      fluid
      class="col-md-11 col-lg-10 border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
    >
      <div class="d-flex justify-content-center align-items-center py-2">
        <div class="col-1">
          <b-button
            :style="{ 'background-image': `url(${'/svg/arrow_left.svg'})` }"
            variant="light py-3 px-2"
            @click="mese--"
            :disabled="disableLeft"
            class="arrow"
          ></b-button>
        </div>
        <!-- <div class="col-5 d-flex mx-3 justify-content-center align-items-center"> -->
        <transition-group
          v-if="isMobile"
          tag="div"
          name="list"
          class="col-5 d-flex mx-3 justify-content-center align-items-center"
        >
          <span
            v-for="(mese, ind) in toShow"
            :key="ind"
            class="mx-2 font-weight-bold text-capitalize"
            :class="
              ind != 1
                ? 'text-disabled-grey point on__hover hide__this'
                : 'text-secondary bigger__text'
            "
            @click="changeMonth(ind)"
          >{{ mese.value }}</span>
        </transition-group>
        <transition-group
          v-else
          tag="div"
          name="list"
          class="col-5 d-flex mx-3 justify-content-center align-items-center"
        >
          <span
            v-for="(mese, ind) in toShow"
            :key="ind"
            class="mx-2 font-weight-bold text-capitalize"
            :class="
              ind != 1
                ? 'text-disabled-grey point on__hover '
                : 'text-secondary bigger__text'
            "
            @click="changeMonth(ind)"
          >{{ mese.value }}</span>
        </transition-group>
        <!-- </div> -->
        <div class="col-1">
          <b-button
            :style="{ 'background-image': `url(${'/svg/arrow_right.svg'})` }"
            variant="light py-3 px-2"
            @click="mese++"
            :disabled="disableRight"
            class="arrow"
          ></b-button>
        </div>
      </div>
      <div class="pr-1 pt-2">
        <b-overlay
          :show="loading"
          rounded="sm"
          spinner-variant="secondary"
          class="col-sm-12 col-lg-10 mx-auto mt-2 pl-1 pr-2 d-flex flex-column justify-content-center overflow__box__m"
        >
          <div
            v-for="(consulto, ind) in elenco"
            :key="ind"
            class="d-flex justify-content-between pr-2"
          >
            <span
              class="px-0 text-left text-secondary font-weight-bold"
              :class="isMobile ? 'col-6' : 'col-3'"
            >{{ consulto.other_anagrafica.fullname }}</span>
            <span
              :class="isMobile ? 'col-6' : 'col-3'"
              class="px-0 text-center"
            >{{ consulto.data_inizio | moment("dddd D, HH:mm") }}</span>
            <span
              class="px-0 text-primary font-weight-bold"
              :class="isMobile ? 'col-6' : 'col-3'"
              v-if="consulto.confirmed"
            >confermato</span>
            <span
              :class="isMobile ? 'col-6' : 'col-3'"
              class="px-0 text-orange font-weight-bold"
              v-else
            >non confermato</span>
            <span
              class="px-0 text-primary underlined point font-weight-bold"
              :class="isMobile ? 'col-6' : 'col-2'"
              @click="showModal(consulto.hashid)"
            >questionario</span>
            <span
              v-if="consulto.note"
              class="px-0 text-secondary underlined point font-weight-bold"
              :class="isMobile ? 'col-4' : 'col-1'"
              @click="showNote(consulto.note)"
            >note</span>
            <span
              v-else
              class="px-0 text-secondary underlined point font-weight-bold"
              :class="isMobile ? 'col-4' : 'col-1'"
            ></span>
            <!-- <span class="col-3 px-0">{{consulto.hashid}}</span> -->
          </div>
          <p
            v-if="elenco && elenco.length == 0"
          >Nessun appuntamento registrato per il mese di {{ mesi[mese].value }}</p>
        </b-overlay>
      </div>
    </b-container>
    <!-- The modal -->
    <b-modal
      ref="questionario"
      size="xl"
      title="Questionario"
      scrollable
      centered
      header-bg-variant="secondary"
      header-text-variant="white font-weight-bold"
      cancel-disabled
      ok-disabled
      ok-only
    >
      <recap-questionario :consulto_rif="questionario" />
    </b-modal>
    <b-modal
      ref="note"
      size="xl"
      title="Note"
      scrollable
      centered
      header-bg-variant="secondary"
      header-text-variant="white font-weight-bold"
      cancel-disabled
      ok-disabled
      ok-only
    >
      <p v-if="this.note">{{this.note.appunti}}</p>
    </b-modal>
  </div>
</template>
<script>
import RecapQuestionario from "@/components/RecapQuestionario";
import moment from "moment";
export default {
  name: "prenotazioni",
  components: { RecapQuestionario },
  data() {
    return {
      elenco: null,
      mese: moment().month(),
      loading: true,
      mesi: [
        { index: 1, value: "gennaio" },
        { index: 2, value: "febbraio" },
        { index: 3, value: "marzo" },
        { index: 4, value: "aprile" },
        { index: 5, value: "maggio" },
        { index: 6, value: "giugno" },
        { index: 7, value: "luglio" },
        { index: 8, value: "agosto" },
        { index: 9, value: "settembre" },
        { index: 10, value: "ottobre" },
        { index: 11, value: "novembre" },
        { index: 12, value: "dicembre" }
      ],
      toShow: [],
      disableLeft: false,
      disableRight: false,
      questionario: null,
      note: null
    };
  },
  watch: {
    mese: function() {
      return this.handleMonthsToShow();
    }
  },
  computed: {
    prevMonth: function() {
      return this.mese >= 1 ? this.mese - 1 : 12;
    },
    nextMonth: function() {
      return this.mese >= 12 ? this.mese + 1 : 0;
    },
    isMobile: function() {
      return this.$root.device < 575;
    }
  },
  methods: {
    fetchData() {
      var query = parseInt(this.mese) + 1;
      var url = process.env.VUE_APP_VERSION + "consulto/all?mese=" + query;

      this.$axios
        .get(url)
        .then(res => {
          this.elenco = res.data.data;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleMonthsToShow() {
      this.loading = true;
      this.fetchData();
      if (this.mese === 0) {
        this.toShow = [];
        this.disableLeft = true;
        return this.toShow.push(this.mesi[11], this.mesi[0], this.mesi[1]);
      }
      if (this.mese === 11) {
        this.toShow = [];
        this.disableRight = true;
        return this.toShow.push(this.mesi[10], this.mesi[11], this.mesi[0]);
      }
      this.toShow = [];
      this.disableLeft = false;
      this.disableRight = false;
      this.toShow.push(
        this.mesi[this.mese - 1],
        this.mesi[this.mese],
        this.mesi[this.mese + 1]
      );
    },
    changeMonth(ind) {
      switch (ind) {
        case 0:
          return this.mese--;
        case 2:
          return this.mese++;
      }
    },
    showModal(rif) {
      this.questionario = rif;
      this.$refs["questionario"].show();
    },
    hideModal() {
      this.questionario = null;
      this.$refs["questionario"].hide();
    },
    showNote(rif) {
      this.note = rif;
      this.$refs["note"].show();
    },
    hideNote() {
      this.note = null;
      this.$refs["note"].hide();
    }
  },
  created() {
    this.fetchData();
    this.handleMonthsToShow();
  },
  mounted() {
    // this.handleMonthsToShow();
  }
};
</script>
<style scoped>
.hide__this {
  visibility: hidden;
}
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  /* transform: translateX(50px) scaleY(0.5); */
  transform: translateX(0) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  /* transform: translateX(0) scaleY(1); */
  transform: translateX(0) scaleY(0.5);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  /* transform-origin: center top; */
}

/* .slide-leave-active,
.slide-enter-active,
.list-move {
  transition: 500ms;
}
.slide-enter {
  transform: translateX(100%, 0);
}
.slide-leave-to {
  transform: translateX(-100%, 0);
} */
.overflow__box__m p {
  margin-top: 0;
  margin-bottom: auto;
}
.overflow__box__m div {
  margin-top: 0;
  margin-bottom: 0.25rem;
  transition: all 500ms;
}
.overflow__box__m div:last-child {
  margin-top: 0;
  margin-bottom: auto;
}
.on__hover:hover {
  font-size: 1rem;
}
</style>
